module.exports = __webpack_public_path__ + "img/foto_2.819d4f55.jpg";